import React from "react";
import {Badge} from "react-bootstrap";

// Einheitliche Beschriftung (siehe auch campaignStatusLabels.js für den
// Kampagnen-Status selbst - das hier ist der Status je EMPFÄNGER).
const STATUS_MAP = {
    pending: {label: "Offen", variant: "secondary"},
    queued: {label: "Eingeplant", variant: "info"},
    sent: {label: "Gesendet", variant: "success"},
    failed: {label: "Fehlgeschlagen", variant: "danger"},
    skipped: {label: "Übersprungen", variant: "warning"},
};

/**
 * Status-Badge für campaign_recipients.status (pending/queued/sent/failed/
 * skipped) - eigene Zelle statt der geteilten StatusBadgeTableCell, da deren
 * Statuswerte (pending/processing/completed/failed) nicht übereinstimmen.
 */
export default function RecipientStatusBadgeTableCell({id, className, children, childSwitch}) {
    const raw = React.Children.toArray(children)
        .filter((c) => typeof c === "string" || typeof c === "number")
        .map(String)
        .join("")
        .trim();

    const cfg = STATUS_MAP[raw] || {label: raw || "–", variant: "light"};

    return (
        <td key={id} className={`border px-4 py-2 text-nowrap${className ? " " + className : ""}`}>
            {childSwitch}
            <Badge bg={cfg.variant}>{cfg.label}</Badge>
        </td>
    );
}
